import Brands from './components/Brands';
import { bindActionCreators } from 'redux';
import values from 'lodash/values';
import get from 'lodash/get';
import {connect} from 'react-redux';

import {
  updateBrand
} from '../../shared/redux/entities/actions';

function getAgencyId(state){
  const impersonatedUserId = get(state,['entities','impersonatedUserId']),
    activeUserId = get(state,['entities','activeUserId']);

    if(impersonatedUserId){
      return get(state,['entities','users',impersonatedUserId,'agencyId']);
    } else {
      return get(state,['entities','users',activeUserId,'agencyId']);
    }
}

function mapStateToProps(state){
  const agencyId = getAgencyId(state);

  return {
    agencyId:agencyId,
    brands:values(state.entities.companies).filter((c) => c.agencyId === agencyId && c.isBrand && c.name),
    users:values(state.entities.users).filter((u) => u.agencyId === agencyId),
    campaigns:values(state.entities.campaigns).filter((c) => c.agencyId === agencyId)
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({ updateBrand },dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps)(Brands);



// WEBPACK FOOTER //
// ./src/routes/Brands/index.js